//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { faUser } from '@fortawesome/free-solid-svg-icons'
import { useParams } from "react-router-dom";
import useDictionary from '../hooks/useDictionary';

export default function MenuLinks() {

    const dictionary = useDictionary();
    const params = useParams();

    return (
        <>
            <li className="elements-to-collapse"><a href={`/${params.lang}/store`} title={dictionary.NEW_OFFERS}>{dictionary.NEW_OFFERS}</a></li>
            <li className="elements-to-collapse"><a href={`/${params.lang}/customer`} title={dictionary.CUSTOMER_PANEL}>{dictionary.CUSTOMER_PANEL}</a></li>
            <li className="elements-to-collapse"><a href={`/${params.lang}/b2b-platform/`} title="B2B Platform">B2B</a></li>
            <li><a href={`/${params.lang}/contact`} title={dictionary.CONTACT}>{dictionary.CONTACT}</a></li>
        </>
    )
}